import {
    ListResult,
    ServiceTransferReportsGetByIdParams,
    IServiceTransferReportsDto,
    IServiceTransferReportDto,
    IServiceTransferReportsGetQuery,
    IReserveComputation,
    IServiceIReserveComputationGetQuery,
    IBmoTransaction,
    IBmoTransactionPatchByIdParams,
} from '@shared/api';
import { Api } from '../../Api';

export class TransferReports {
    private static _basePath = '/transfer-reports';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${TransferReports._basePath}`;
        return {
            async getCurrDay(query: IServiceTransferReportsGetQuery) {
                const path = '/curday/';
                return await Api.get<ListResult<IServiceTransferReportsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getPrevDay(query: IServiceTransferReportsGetQuery) {
                const path = '/prevday/';
                return await Api.get<ListResult<IServiceTransferReportsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getReserves(query: IServiceIReserveComputationGetQuery) {
                const path = '/reserves/';
                return await Api.get<IReserveComputation>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getTransactions(query: IServiceTransferReportsGetQuery) {
                const path = '/transactions/';
                return await Api.get<ListResult<IBmoTransaction>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async patchTransactions({ id, body }: IBmoTransactionPatchByIdParams) {
                const path = `/transactions/${id}`;
                return await Api.patch({
                    path: `${basePath}${path}`,
                    body,
                });
            },
            async getCurrDayById({ id }: ServiceTransferReportsGetByIdParams) {
                const path = `/curday/${id}`;
                return await Api.get<IServiceTransferReportDto>({
                    path: `${basePath}${path}`,
                });
            },
            async getPrevDayById({ id }: ServiceTransferReportsGetByIdParams) {
                const path = `/prevday/${id}`;
                return await Api.get<IServiceTransferReportDto>({
                    path: `${basePath}${path}`,
                });
            },
        };
    }
}
